// Utility helpers for category behaviors across the app

// Detect the system withdrawal category without relying on DB flags
// Heuristic: exact French label OR the factor combo used by withdrawal
// Keep strict label first to avoid false positives
// Supports both Category and CategoryDetail structures
export function isWithdrawalCategory(categoryOrDetail) {
  if (!categoryOrDetail) return false;
  
  // Handle both Category and CategoryDetail structures
  const label = (categoryOrDetail.category?.label || categoryOrDetail.label || '').trim();
  const hasWithdrawalLabel = label === 'Sortie Coffre';
  const hasWithdrawalFactors = Number(categoryOrDetail.caisseFactor) === 0 && 
                                Number(categoryOrDetail.coffreFactor) === -1;
  return hasWithdrawalLabel || hasWithdrawalFactors;
}



